// state.js
export default {
  // ...otros estados existentes
  signatureImage: null, // Agregar esta propiedad para almacenar la imagen de la firma
}
